// 📁 src/utils/generateInvoiceEntry.js

export const generateInvoiceEntry = ({
  tenantId,
  companyName,
  email,
  currency,
  method,
  billingCycle,
  annualDiscountRate,
  selectedModules,
  timestamp,
  invoiceNo // ✅ Passed from recordPayment.js
}) => {
  try {
    const customerKey = `invoiceArchive_${email}`;
    const adminKey = `invoiceArchive_admin`;

    const customerArchive = JSON.parse(localStorage.getItem(customerKey) || '[]');
    const adminArchive = JSON.parse(localStorage.getItem(adminKey) || '[]');

    const now = new Date(timestamp);
    const formatMonth = (date) => date.toLocaleString('en-BD', { month: 'short', year: 'numeric' });

    const start = new Date(timestamp);
    const end = new Date(timestamp);
    if (billingCycle === 'monthly') {
      end.setMonth(end.getMonth() + 1);
    } else if (billingCycle === 'annual') {
      end.setFullYear(end.getFullYear() + 1);
    }
    const modulePeriod =
      billingCycle === 'monthly'
        ? formatMonth(start)
        : `${formatMonth(start)} – ${formatMonth(end)}`;

    selectedModules.forEach(({ name, price }) => {
      const invoiceEntry = {
        invoiceNo, // ✅ Use consistent invoiceNo
        billingDate: now.toISOString(),
        tenantId,
        companyName,
        email,
        moduleName: name || 'Unknown Module',
        billingCycle,
        modulePeriod,
        currency,
        baseAmount: price,
        annualDiscountRate,
        totalAmount: price,
        method,
        notes: {
          annualApplied:
            billingCycle === 'annual' && annualDiscountRate > 0
              ? `✓ ${annualDiscountRate}% Annual Discount Applied`
              : '✓ No Annual Discount',
          footer:
            'This is a system-generated e-invoice. For queries, contact billing@talentraxion.com'
        }
      };

      customerArchive.push(invoiceEntry);
      adminArchive.push(invoiceEntry);
    });

    localStorage.setItem(customerKey, JSON.stringify(customerArchive));
    localStorage.setItem(adminKey, JSON.stringify(adminArchive));

    console.log(`🧾 Invoice entries generated for ${companyName}`);
  } catch (error) {
    console.error('Invoice generation failed:', error);
  }
};
